import { RootState } from '@App/redux/store'

export const allTransactions = (state: RootState) => state.reports.transactions

export const selectReportTradesList = (state: RootState) => state.reports.trades

export const selectReportOrdersList = (state: RootState) => state.reports.orders